import { Container } from 'pixi.js';
import { GameItemConfig } from '../../Config/Items';
import Core from '../../Core/Core';
import { gameConfig } from '../../index';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
// import { PopupActions } from '../../State/Actions/Actions';
import { createPixiText, scaleToFit } from '../../Utils/Utils';
import Sprite = PIXI.Sprite;
import { AdButton } from '../Shared/Buttons/AdButton';
import { TextButton } from '../Shared/Buttons/TextButton';
import { UIButton } from '../Shared/Buttons/UIButton';
import { PlayerCoins } from '../Shared/PlayerCoins';
import { PlayerCoinsSmall } from '../Shared/PlayerCoinsSmall';

export class CurrencyNeededPopup extends Container {
    // private id: string;
    private buyButton: TextButton;
    // private shopButton: TextButton;
    private watchButton: AdButton;
    private playerCoins: PlayerCoins;
    private dismissed: boolean = false;
    private type: Popup;

    constructor(
        currencyId: string,
        coins: number,
        wanted: string,
        outOfCurrency: boolean = true,
        type: Popup = Popup.INSUFFICIENT
    ) {
        super();

        this.type = type;
        let msg;
        if (currencyId === 'coin') {
            msg = Core.local.getText('morecoins');
        } else {
            msg =
                currencyId === 'heart' && outOfCurrency
                    ? Core.local.getText('nolives')
                    : currencyId === 'heart' && !outOfCurrency
                        ? ''
                        : Core.local.getText('nocoins');
        }
        let texture;
        if (currencyId === 'coin') {
            texture = 'commonui/reward-coin02';
        } else {
            texture =
                currencyId === 'heart' && outOfCurrency
                    ? 'commonui/icon-heart-broken-small'
                    : currencyId === 'heart' && !outOfCurrency
                        ? 'commonui/reward-heart'
                        : 'mapui/booster-' + currencyId.toLowerCase();
        }

        const bgWidth = gameConfig.game_width * 0.9;
        const bgHeigth = gameConfig.game_height * 0.55;

        const bgtexture = PIXI.utils.TextureCache['commonui/popup-bg'];
        const bg = new PIXI.mesh.NineSlicePlane(bgtexture, 100, 100, 100, 100);
        bg.width = bgWidth;
        bg.height = bgHeigth;
        bg.interactive = true;
        const offset = Core.sdk.payments.enabled ? 0 : bgHeigth * 0.1;
        const txtDisplay = createPixiText(
            msg,
            new PIXI.Rectangle(
                bgWidth * 0.5,
                offset + bgHeigth * 0.12,
                bgWidth * 0.7,
                bgHeigth * 0.3
            ),
            'Baloo',
            35,
            28,
            0x006eba
        );
        txtDisplay.anchor.set(0.5);

        const icon = new Sprite(PIXI.utils.TextureCache[texture]);
        icon.scale.set(2);
        icon.anchor.set(0.5);
        icon.x = bgWidth * 0.5;
        icon.y = offset + bgHeigth * 0.3;

        const playerCoins = new PlayerCoins(bgWidth * 0.5, bgHeigth * 0.1, coins);
        playerCoins.x = bgWidth * 0.5 - playerCoins.width * 0.25;
        playerCoins.y = bgHeigth * 0.027;

        const closeBtn = new UIButton('commonui/button-close');
        closeBtn.bg.anchor.set(1, 0);
        closeBtn.x = bgWidth;
        closeBtn.once('trigger', this.handleClose.bind(this));

        //@ts-ignore
        this.addChild(bg, txtDisplay, icon, playerCoins, closeBtn);

        let price = 0;
        if (currencyId !== 'coin') {
            price = GameItemConfig[wanted].price;
            const boosterPrice = new PlayerCoinsSmall(bgWidth * 0.3, bgHeigth * 0.1, price);
            boosterPrice.anchor.set(0.5);
            boosterPrice.x = icon.x;
            boosterPrice.y = icon.y + icon.width * 0.7;
            this.addChild(boosterPrice);
        }

        // TODO pass in rewarded, remove gamesdk ref
        if (
            (Core.sdk.ads.getRewardedEnabled() && coins < price) ||
            (currencyId === 'coin' && Core.sdk.ads.getRewardedEnabled())
        ) {
            const watch = new AdButton(bgWidth * 0.6, bgHeigth * 0.15, Core.local.getText('watch'));
            watch.x = bgWidth * 0.5;
            watch.y = bgHeigth * 0.85;
            watch.interactive = true;
            watch.buttonMode = true;
            watch.once('trigger', this.handleAd.bind(this));
            this.addChild(watch);
            this.watchButton = watch;
        }

        if (coins >= price && currencyId !== 'coin') {
            const buyButton = new TextButton({
                width: bgWidth * 0.6,
                height: bgHeigth * 0.15,
                btnText: Core.local.getText('buy'),
            });
            buyButton.x = bgWidth * 0.5;
            buyButton.y = bgHeigth * 0.85;
            buyButton.once('trigger', this.handleBuy.bind(this));
            this.addChild(buyButton);
            this.buyButton = buyButton;
        }

        if (Core.sdk.payments.enabled) {
            const shopButton = new TextButton({
                width: bgWidth * 0.6,
                height: bgHeigth * 0.15,
                btnText: Core.local.getText('shop'),
            });

            const positionBtn = this.watchButton || this.buyButton || null;
            if (positionBtn) {
                shopButton.scale.set(
                    scaleToFit(
                        shopButton.width,
                        shopButton.height,
                        positionBtn.width * 0.85,
                        positionBtn.height * 0.85
                    )
                );
            }

            shopButton.x = bgWidth * 0.5;
            shopButton.y = positionBtn ? positionBtn.y - positionBtn.height : bgHeigth * 0.85;
            shopButton.on('trigger', this.handleShop.bind(this));
            this.addChild(shopButton);
            // this.shopButton = shopButton;
        }

        // this.id = currencyId;
        this.playerCoins = playerCoins;
    }

    public enableBuy() {
        this.buyButton.interactive = true;
        this.buyButton.buttonMode = true;
        this.buyButton.alpha = 1;
    }

    public updateCoins(amt: number) {
        this.playerCoins.updatedCoinTxt(amt);
    }

    private handleAd(e: PIXI.interaction.InteractionEvent) {
        if (this.dismissed) {
            return;
        }
        this.dismissed = true;
        HudEmitter.instance.emit(HudActions.CLOSE_POPUP, this.type, 0, 'watch');
    }

    private handleShop(e: PIXI.interaction.InteractionEvent) {
        if (this.dismissed) {
            return;
        }
        HudEmitter.instance.emit(HudActions.CLOSE_POPUP, this.type, 0, 'shop');
    }

    private handleBuy(e: PIXI.interaction.InteractionEvent) {
        if (this.dismissed) {
            return;
        }
        this.dismissed = true;
        HudEmitter.instance.emit(HudActions.CLOSE_POPUP, this.type, 0, 'buy');
    }

    private handleClose(e: PIXI.interaction.InteractionEvent) {
        if (this.dismissed) {
            return;
        }
        this.dismissed = true;
        HudEmitter.instance.emit(HudActions.CLOSE_POPUP, this.type, 0, 'close');
    }
}
